import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import * as Auth from '@aws-amplify/auth'
import { Amplify } from 'aws-amplify'

import amplifyConfig from '../amplify.config'

// Amplify-Konfiguration einmalig initialisieren
Amplify.configure(amplifyConfig)

export const authGuard: CanActivateFn = () => {
  const router = inject(Router)

  return Auth.getCurrentUser().then(
    () => true,
    (err) => {
      console.error('Error fetching session or user not authenticated', err)
      return router.createUrlTree(['login'])
    }
  )
}
